module.exports = __webpack_public_path__ + "img/dc1_mb.3fc48b85.jpg";